import React from "react";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const Breadcrumb = ({title,parent}) => {
	return (
		<Container fluid={true}>
			<div className="page-header" style={{paddingTop:8,paddingBottom:8}}>
				<Row>
					<Col lg="6">
						<div className="page-header-left" >
							<h3 style={{color:'#EF4123'}}>
								{title}								
							</h3>
						</div>
					</Col>
					<Col lg="6">
					{parent}
					
					</Col>
				</Row>
			</div>
		</Container>
	);
};

export default Breadcrumb;
